import React from 'react';

// Small inline chip. Two roles per DESIGN.md §6.1 VectorPill:
//   - Filter chip (with optional leading line-icon)
//   - Qualitative badge (with leading Aurum dot)
const VectorPill = ({
  children,
  variant = 'filter', // 'filter' | 'qualitative'
  icon,
  className = '',
}) => {
  const dot = variant === 'qualitative';
  return (
    <span
      className={[
        'inline-flex items-center gap-2',
        'h-7 px-3.5',
        'bg-card-sheen border border-hairline-soft',
        'font-display uppercase tracking-[0.08em] text-bone',
        'rounded-full',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ fontSize: 10 }}
    >
      {dot && (
        <span
          className="w-1.5 h-1.5 rounded-full bg-aurum"
          aria-hidden="true"
        />
      )}
      {!dot && icon && (
        <span className="inline-flex items-center w-3 h-3 text-bone-dim">
          {icon}
        </span>
      )}
      {children}
    </span>
  );
};

export default VectorPill;
